import { useApp } from '../app/app_provider';


export default function useNavigateTo() {
  const app = useApp();

  return function navigateTo(path, options) {
    app.methods.navigateTo({ app, path, options });
  };
}
